import React, { useEffect } from 'react';
import {
  Grid, Paper, Box, TextField, Typography,
  Button 
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useForm, Controller } from "react-hook-form";

const AccountInfo = ({ accountDetails, updateProfileInfo }) => {

  /** Hooks */
  const { handleSubmit, control, formState: { errors }, reset } = useForm({
    mode: 'onTouched',
    defaultValues: {...accountDetails}
  });

  useEffect(() => {
    reset({...accountDetails})
  }, [accountDetails, reset])

  const onSubmit = (data) => {
    updateProfileInfo({...data });
  }
  
  // const disabled = useMemo(() => (accountDetails?.checkin === 'Y'), [accountDetails.checkin])

  return ( 
    <Paper  sx={{mt: 0,
      // boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
      boxShadow: 'none'
    }}>
      <Grid
        container
        direction="row"
        justifyContent="left"
        alignItems="center"
      >
        <Box noValidate component="form"  onSubmit={handleSubmit(onSubmit)} sx={{  p:4,  }} >
          <Typography variant="h6"  sx={{mb: 2}}>
            Update account details
          </Typography>
          <Grid container columnSpacing={2} rowSpacing={0}>
            <Grid item xs={12} sm={12} md={6} lg={6}  >
              <Controller
                control={control}
                name="firstName"
                id="firstName"
                rules={{ required: "Enter your first name" }}
                render={({field }) => (
                  <TextField
                    {...field}
                    margin="normal"
                    fullWidth
                    size="small"
                    autoFocus
                    label="First Name"
                    required
                    error={errors.firstName?.type === 'required'}
                    // helperText={errors.firstName?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} >
              <Controller
                control={control}
                name="lastName"
                id="lastName"
                rules={{ required: "Enter your last name" }}
                render={({field}) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="last Name"
                    required
                    error={errors.lastName?.type === 'required'}
                    // helperText={errors.mobile?.message}

                    size="small"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} >
              <Controller
                control={control}
                name="email"
                id="email"
                readOnly
                rules={{ required: "Enter your email",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "Enter a valid email address",
                  }, 
                }}
                render={({field}) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="Email"
                    required
                    error={errors.email?.type === 'required'}
                    // disabled={true}
                    size="small"
                    fullWidth
                    readOnly
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} >
              <Controller
                control={control}
                name="mobile"
                id="mobile"
                rules={{ required: "Enter mobile number" }}
                render={({field}) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="Mobile Number"
                    disabled={true}
                    required
                    error={errors.mobile?.type === 'required'}
                    // helperText={errors.lastName?.message}
                    size="small"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="right"
              alignItems="center"
            >
              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 6, mb: 2 }}
                startIcon={<EditIcon />}
                color="success"
              >
                Update Account
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Paper>
  );
}
 
export default React.memo(AccountInfo);
